import { useRouteMatch } from 'react-router-dom'

// * * this only considers /document/:id (assignment only)
// extend this for private docs as well
export function useIsPepperDocsRoute() {
  const pepperDocRouteMatch = useRouteMatch<{ id: string }>('/document/:id')
  return pepperDocRouteMatch ? true : false
}
